import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { Fixtures } from '../fixtures';

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss']
})
export class ContentComponent implements OnInit {
  modules: any[];

  constructor(
      private entites: Fixtures,
      private modalService: NgbModal
  ) { }

  ngOnInit(): void {
    this.modules = this.entites.modules;
  }

}



// WEBPACK FOOTER //
// /var/www/ras.universarium.org/www/src/app/content/content.component.ts